import script from "./brands.vue?vue&type=script&setup=true&lang=js"
export * from "./brands.vue?vue&type=script&setup=true&lang=js"

import "./brands.vue?vue&type=style&index=0&id=2ea346c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea346c0"]])

export default __exports__